import { z } from 'zod';
// ─── Worker heartbeat ────────────────────────────────────────────────────────
/**
 * Emitted every ~10s by runner + webhook-dispatcher into Redis at
 * `cortex:worker:<service>:<podId>` with a 30s TTL. A key missing = pod
 * died or was rolled; presence + freshness = liveness signal for
 * /v1/system/workers.
 */
export const WorkerServiceSchema = z.enum([
    'runner',
    'webhook-dispatcher',
    'orchestrator',
    'persistent-agent-host',
]);
export const WorkerHeartbeatSchema = z.object({
    service: WorkerServiceSchema,
    /** Stable per-process id. Defaults to HOSTNAME (k8s pod name) if set, else PID. */
    podId: z.string().min(1),
    /** ISO timestamp of the last emitted beat. */
    lastSeenAt: z.string().datetime(),
    /** Optional app-specific info. */
    metadata: z.record(z.string(), z.unknown()).optional(),
});
// ─── Queue stats ─────────────────────────────────────────────────────────────
/**
 * BullMQ queue summary for /v1/system/queue. Waiting > 0 when runner is
 * overloaded or down; failed > 0 surfaces recently-failed job bodies.
 */
export const QueueStatsSchema = z.object({
    name: z.string(),
    waiting: z.number().int().nonnegative(),
    active: z.number().int().nonnegative(),
    completed: z.number().int().nonnegative(),
    failed: z.number().int().nonnegative(),
    delayed: z.number().int().nonnegative(),
    paused: z.number().int().nonnegative(),
});
// ─── System health ───────────────────────────────────────────────────────────
export const DependencyHealthSchema = z.object({
    name: z.string(),
    ok: z.boolean(),
    latencyMs: z.number().int().nonnegative().optional(),
    error: z.string().optional(),
});
export const SystemHealthSchema = z.object({
    status: z.enum(['ok', 'degraded', 'down']),
    ts: z.number().int(),
    dependencies: z.array(DependencyHealthSchema),
});
//# sourceMappingURL=ops.js.map